export default __webpack_public_path__ + "static/media/Logo_UBosque.846d58e3.svg";